import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipImg/vip_recommon_left.png'
import _imports_1 from '@/assets/image/vipImg/vip_recommon_right.png'
import _imports_2 from '@/assets/image/vipImg/vip-equity-right.png'
import _imports_3 from '@/assets/image/vipImg/vip-equity-error.png'


const _withScopeId = n => (_pushScopeId("data-v-395617e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "tabs" }
const _hoisted_10 = { class: "equity" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = { class: "marks" }
const _hoisted_13 = {
  key: 0,
  class: "abs newMemberBlock"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "abs newMemberTitle flex-cen-ter" }, "- 新規限定 -", -1))
const _hoisted_16 = { class: "abs newMemberTag flex-cen-ter" }
const _hoisted_17 = { class: "tr" }
const _hoisted_18 = { class: "td thead" }
const _hoisted_19 = { class: "td active thead" }
const _hoisted_20 = { class: "td thead" }
const _hoisted_21 = { class: "td" }
const _hoisted_22 = { class: "active td" }
const _hoisted_23 = { class: "icon" }
const _hoisted_24 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_25 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_26 = {
  key: 0,
  class: "mark"
}
const _hoisted_27 = { class: "td" }
const _hoisted_28 = { class: "icon" }
const _hoisted_29 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_30 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_31 = {
  key: 0,
  class: "mark"
}

import { PropType, ref, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { formatMoney } from '@/plugins/utils'
// 推荐内容
interface listItem {
  generalRemark: string,
  generalRemarkOnly: number,
  generalStatus: number,
  id: number,
  isDelete: number,
  membershipTemplateId: number,
  rightName: string,
  specialRemark: string,
  specialRemarkOnly: number,
  specialStatus: number,
  status: number,
  systemSource: number
}

export default /*#__PURE__*/_defineComponent({
  props: {
  tblist: {
    type: Array as PropType<listItem[]>,
    default: () => []
  },
  tclist: {
    type: Array as PropType<listItem[]>,
    default: () => []
  },
  newSpecialMemberFlag: {
    type: Boolean,
    default: false
  },
  newSpecialMember: {
    type: Object,
    default: () => { }
  }
},
  setup(__props) {

const props = __props
const memberLeft = require('@/assets/image/icon/member/member-left.png')

const showList = ref([] as listItem[])


// : newSpecialMemberFlag = "newSpecialMemberFlag" : newSpecialMember = "newSpecialMember"
// 会员标记
// const newMemberFlag = props.vipInfo.priceItemList?.some((v: any) => v.trialFlag)
const newMemberFlagIcon = require('@/assets/image/icon/member/newmember_tag_trapezoid@2x.png')
// const newMemberTag = '148,000円'
onMounted(() => {
  seletActive(1)
})

// tab激活
const tabIndex = ref(1)
// 切换tab
const seletActive = (value: number) => {
  tabIndex.value = value
  const newShowList = value === 1 ? props.tblist : props.tclist
  showList.value = newShowList.filter(i => i.status)
}
// 跳转常规权益页面
const goEquity = () => {
  window.open('https://www.theckb.com/price/plan/', '_blank')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('THE CKB专属会员权益')), 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('PRO会员尊享：常规权益+PRO追加权益，查看')), 1),
      _createElementVNode("span", {
        class: "link",
        onClick: goEquity
      }, [
        _createTextVNode(_toDisplayString(_unref(t)('常规权益')) + " ", 1),
        _createElementVNode("img", {
          src: _unref(memberLeft),
          alt: "",
          style: {"width":"16px","height":"16px"},
          class: "right"
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (seletActive(1))),
          class: _normalizeClass(`b2b tab ${tabIndex.value === 1 ? 'active' : ''}`)
        }, "B2B", 2),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (seletActive(2))),
          class: _normalizeClass(`d2c tab ${tabIndex.value === 2 ? 'active' : ''}`)
        }, "D2C", 2)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (__props.newSpecialMemberFlag && __props.newSpecialMember.trialDiscount === -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("img", {
                    src: _unref(newMemberFlagIcon),
                    alt: ""
                  }, null, 8, _hoisted_14),
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(formatMoney)(__props.newSpecialMember.trialPrice)) + "円", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('功能特权')), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('您的专属权益')), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('非会员')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tr",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(item.rightName), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (!item.specialRemarkOnly && item.specialStatus === 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                    : _createCommentVNode("", true),
                  (!item.specialRemarkOnly && item.specialStatus === 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                    : _createCommentVNode("", true)
                ]),
                (item.specialRemark)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item.specialRemark), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  (!item.generalRemarkOnly && item.generalStatus === 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                    : _createCommentVNode("", true),
                  (!item.generalRemarkOnly && item.generalStatus === 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_30))
                    : _createCommentVNode("", true)
                ]),
                (item.generalRemark)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(item.generalRemark), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})